
export const environment = {
  production: true,
  apiUrl: 'https://api.catholiclegacy.com',
  webUrl: 'https://www.catholiclegacy.com',
  SENTRY_AUTH_TOKEN: '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'
};
